import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';

import { Site, SiteType } from '@iot-platform/models/i4b';
import { InfoDisplayPipe } from '@iot-platform/pipes';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  imports: [InfoDisplayPipe, TranslatePipe],
  providers: [InfoDisplayPipe],
  selector: 'iot-platform-ui-detail-site-card',
  templateUrl: './detail-site-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./detail-site-card.component.scss']
})
export class DetailSiteCardComponent {
  protected readonly SiteType = SiteType;

  site = input<Site>();

  selectSite = output<Site>();
}
